import { useMemo } from 'react';
import { useTranslation } from '../../../contexts/translation-context';
import { useConfig } from '../../../contexts/config-context';
import { getCallingCode } from './phone-input-utils';
import { isSupportedCountry } from 'libphonenumber-js';
import { CALLING_COUNTRY_CODES } from '@wix/form-validator';
export function useCountries() {
  const {
    t
  } = useTranslation();
  const {
    locale
  } = useConfig();
  const countries = useMemo(() => {
    return Object.keys(CALLING_COUNTRY_CODES).reduce((result, shortCountryCode) => {
      const longCountryCode = CALLING_COUNTRY_CODES[shortCountryCode];
      const callingCode = getCallingCode(longCountryCode);
      const countryName = t(`locale-dataset.countries.${longCountryCode.toUpperCase()}`);
      if (callingCode && isSupportedCountry(shortCountryCode)) {
        result.push({
          countryName,
          longCountryCode,
          shortCountryCode,
          callingCode
        });
      }
      return result;
    }, []).sort((a, b) => a.countryName.localeCompare(b.countryName, locale));
  }, [t, locale]);
  return countries;
}
export function searchCountries(countries, searchPhrase) {
  return countries.filter(country => isCountryMatching(country, searchPhrase));
}
export function filterCountries(countries, allowedCountryCodes) {
  return countries.filter(country => allowedCountryCodes && allowedCountryCodes.length > 0 ? allowedCountryCodes.includes(country.shortCountryCode) : true);
}
export function isCountryMatching(country, searchPhrase) {
  const {
    countryName,
    callingCode,
    shortCountryCode
  } = country;
  if (isSubstring(countryName, searchPhrase)) {
    return true;
  }
  if (isSubstring(callingCode, searchPhrase)) {
    return true;
  }
  if (isSubstring(shortCountryCode, searchPhrase)) {
    return true;
  }
  return false;
}
function isSubstring(full, part) {
  return full.toLowerCase().includes(part.toLowerCase());
}
//# sourceMappingURL=use-countries.js.map